module.exports = __webpack_public_path__ + "static/media/heart-search.23bb4c10.svg";